import React, { useState, useRef, useEffect } from "react";
import "./Home.css";
// MUI Components for Detail View
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Button,
  Typography,
  CardContent,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import whatsapp from "../assets/whatsapp.png";
import HeroVideo1 from "../assets/hero1.mp4";
import HeroVideo2 from "../assets/hero2.mp4";
import HeroVideo3 from "../assets/hero3.mp4";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

// Gallery Images
import image1 from "../assets/image1.png";
import image2 from "../assets/image2.png";
import image3 from "../assets/image3.png";
import image4 from "../assets/image4.png";
import image5 from "../assets/image5.png";
import image6 from "../assets/image6.png";

import swiss1 from "./International/IntImages/swiss/swiss1.png";
import kerala2 from "./Domestic/DomImages/kerala/kerala2.png";
import thailand1 from "./International/IntImages/thailand/thailand1.png";
import phuket1 from "./International/IntImages/phuket/phuket1.png";
import maldives1 from "./International/IntImages/maldives/maldives1.png";
import kashmir3 from "./Domestic/DomImages/kashmir/kashmir1.png";
import rajasthan1 from "./Domestic/DomImages/rajasthan/rajasthan1.png";
import goa1 from "./Domestic/DomImages/goa/goa2.png";
import vietnam1 from "./International/IntImages/vietnam/vietnam1.png";
import bali1 from "./International/IntImages/bali/bali1.png";
import shimla2 from "./Domestic/DomImages/shimla/shimla2.png";
import mussoorie1 from "./Domestic/DomImages/mussoorie/mussoorie2.jpg";

// New Full-Page Component for Package Details (Refactored)
const PackageDetailView = ({ pkg, setExpandedPackage, whatsappNumber }) => {
  const [expandedDays, setExpandedDays] = useState({});

  const handleDayAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedDays((prevState) => ({
      ...prevState,
      [panel]: isExpanded,
    }));
  };

  const handleExpandAll = () => {
    const allExpanded = pkg.itinerary.reduce((acc, item, index) => {
      acc[`day-${index}`] = true;
      return acc;
    }, {});
    setExpandedDays(allExpanded);
  };

  const handleCollapseAll = () => {
    setExpandedDays({});
  };

  const whatsappLink = `https://wa.me/${whatsappNumber}?text=I%20am%20interested%20in%20the%20${encodeURIComponent(
    pkg.title
  )}%20package%20(${
    pkg.days
  }%20Days).%20Please%20send%20me%20booking%20details.`;

  // 1. Overview Accordion Component
  const overviewAccordion = (
    <Accordion
      defaultExpanded
      className="detail-itinerary-accordion detail-overview-accordion"
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6" className="accordion-main-title">
          Overview
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <ul className="detail-info-list">
          <li>{pkg.overview}</li>
        </ul>
      </AccordionDetails>
    </Accordion>
  );

  // 2. Inclusions Accordion Component
  const inclusionsAccordion = (
    <Accordion
      defaultExpanded
      className="detail-itinerary-accordion detail-inclusions-accordion"
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6" className="accordion-main-title">
          Inclusions
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <ul className="inclusion-custom-list">
          {pkg.inclusions.map((item, index) => (
            <li key={`inc-${index}`}>{item}</li>
          ))}
        </ul>
      </AccordionDetails>
    </Accordion>
  );

  // 3. Exclusions Accordion Component
  const exclusionsAccordion = (
    <Accordion
      defaultExpanded
      className="detail-itinerary-accordion detail-exclusions-accordion"
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6" className="accordion-main-title">
          Exclusions
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <ul className="exclusion-custom-list">
          {pkg.exclusions.map((item, index) => (
            <li key={`exc-${index}`}>{item}</li>
          ))}
        </ul>
      </AccordionDetails>
    </Accordion>
  );

  return (
    <div className="destination-detail-page">
      {/* Detail Header Bar */}
      <div className="detail-navigation-header">
        <button
          className="back-to-list-button"
          onClick={() => setExpandedPackage(null)}
        >
          &larr; Back to Packages
        </button>
      </div>

      {/* Main Content Area */}
      <div className="detail-main-content">
        {/* LEFT COLUMN */}
        <div className="detail-primary-column">
          {/* Image */}
          <div className="detail-image-wrapper">
            <img
              src={pkg.image}
              alt={pkg.title}
              className="detail-hero-image"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src =
                  "https://placehold.co/800x500/cccccc/333333?text=Package+Image+Unavailable";
              }}
            />
          </div>

          {/* Title and Duration Tag moved here, just below the image */}
          <div className="title-and-duration-info">
            <h2>{pkg.title}</h2>
            <span className="duration-label">
              <AccessTimeIcon className="duration-icon" />
              {pkg.days} Days / {pkg.nights} Nights
            </span>
          </div>

          {/* Overview for Mobile/Tablet */}
          <Box className="overview-mobile-container">{overviewAccordion}</Box>

          {/* Detailed Itinerary Accordion */}
          <Accordion defaultExpanded className="detail-itinerary-accordion">
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6" className="accordion-main-title">
                Detailed Itinerary
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              {/* Expand/Collapse buttons for Detailed Itinerary */}
              <Box className="itinerary-action-controls">
                <Button
                  onClick={handleExpandAll}
                  variant="outlined"
                  size="small"
                  className="itinerary-toggle-button"
                >
                  Expand All
                </Button>
                <Button
                  onClick={handleCollapseAll}
                  variant="outlined"
                  size="small"
                  className="itinerary-toggle-button"
                >
                  Collapse All
                </Button>
              </Box>

              {/* Itinerary uses nested accordions */}
              {pkg.itinerary.map((item, index) => (
                <Accordion
                  key={index}
                  disableGutters
                  className="day-plan-accordion"
                  expanded={expandedDays[`day-${index}`] || false}
                  onChange={handleDayAccordionChange(`day-${index}`)}
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="subtitle1" component="div">
                      <span className="day-title-emphasis">
                        {item.day || `Day ${index + 1}`}:
                      </span>{" "}
                      <span className="day-title-emphasis">
                        {item.title || item.details}
                      </span>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    {/* Day Details content in ul li format - MODIFIED BLOCK */}
                    <div className="day-detail-list">
                      {Array.isArray(item.details) ? (
                        <ul
                          className="itinerary-day-list"
                          style={{ paddingLeft: 0, margin: 0 }}
                        >
                          {item.details.map((detail, detailIndex) => (
                            <li key={`day-${index}-detail-${detailIndex}`}>
                              {detail}
                            </li>
                          ))}
                        </ul>
                      ) : (
                        // Fallback for string details if not an array (e.g., in domestic packages)
                        <li>{item.details}</li>
                      )}
                    </div>
                  </AccordionDetails>
                </Accordion>
              ))}
            </AccordionDetails>
          </Accordion>

          {/* Inclusions Accordion */}
          {inclusionsAccordion}

          {/* Exclusions Accordion */}
          {exclusionsAccordion}
        </div>

        {/* RIGHT COLUMN (Booking/Contact) */}
        <Box className="detail-secondary-column">
          {/* Overview for Desktop */}
          <Box className="overview-desktop-container">{overviewAccordion}</Box>

          {/* Booking/Contact Section */}
          {/* <Box className="contact-action-box">
            <a
              href={whatsappLink}
              target="_blank"
              rel="noreferrer"
              className="whatsapp-contact-button"
            >
              <WhatsAppIcon />
              Contact us for Booking
            </a>
          </Box> */}

          <Box className="contact-action-box">
            <p className="ready-book">Ready to Book?</p>
            <p className="contact-customize">
              Contact us now to customize your trip or to book this package.
            </p>
            <div>
              <a
                href={whatsappLink}
                target="_blank"
                rel="noreferrer"
                className="whatsapp-contact-button"
              >
                <WhatsAppIcon />
                Chat Us on WhatsApp
              </a>
            </div>
          </Box>
        </Box>
      </div>
    </div>
  );
};
// END PackageDetailView Component

export default function Home() {
  const videos = [HeroVideo1, HeroVideo2, HeroVideo3];
  const [currentVideo, setCurrentVideo] = useState(0);

  // States for Package View
  const [selectedPackage, setSelectedPackage] = useState(null);

  // States for Gallery Modal
  const [showGalleryModal, setShowGalleryModal] = useState(false);
  const [selectedGalleryImage, setSelectedGalleryImage] = useState(null);

  // Carousel States and Refs
  const [activeIntIndex, setActiveIntIndex] = useState(0);
  const internationalCarouselRef = useRef(null);
  const [activeDomIndex, setActiveDomIndex] = useState(0);
  const domesticCarouselRef = useRef(null);
  const [activeGalleryIndex, setActiveGalleryIndex] = useState(0);
  const galleryCarouselRef = useRef(null);

  // Package Data (Updated with Inclusions/Exclusions)
  const internationalPackages = [
    // 3. Thailand Tour 4N/5D
    {
      id: 3,
      title: "Thailand Discovery",
      subtitle: "Bangkok - Pattaya - Coral Island",
      image: thailand1,
      days: 5,
      nights: 4,
      overview: [
        [
          "Thailand is a vibrant destination known for its rich culture, colorful markets, and lively city life. Explore Bangkok’s iconic temples, royal palaces, and bustling floating markets. Enjoy exciting nightlife, street food, and world-class shopping experiences. Discover beautiful beaches and fun activities in Pattaya and nearby islands. Experience traditional Thai massages, cultural shows, and warm hospitality. A Thailand tour offers the perfect balance of culture, entertainment, and relaxation.🇹🇭",
        ],
      ],
      // duration: "4 Nights / 5 Days",
      itinerary: [
        {
          day: " Day 01",
          title: "ARRIVAL AT BANGKOK TO PATTAYA",
          details: [
            "On arrival you will be met by our local representative and go towards pattaya.",
            "En route had your breakfast at sriracha tiger zoo",
            "Had your lunch at Indian restaurant.",
            "After lunch you will go to",
            "Later check in the hotel and had your dinner",
            "Overnight stay at pattaya.",
          ],
        },
        {
          day: "Day 02",
          title: "CORAL ISLAND",
          details: [
            "Visit to Coral Island – the Island",
            "After your luscious breakfast in the morning get set to explore the beauty of Coral Island.",
            "Commence (approx 0800 Hours) with the energizing ride in a speed boat to the KoLarn Island where you can enjoy mu and jet skis.",
            "Snorkeling and deep",
            "KohKrok and KohSak, where there is an abundance of coral and undersea life waiting to be discovered.",
            "Also view the colorful and bountiful underwater life without getting wet as you gaze at them from aboard a glass bottom boat.",
            "Rest of the day is free for your personal activity",
            "Back to the hotel and overnight stay at pattaya.",
          ],
        },
        {
          day: "Day 03",
          title: "PATTAYA – BANGKOK",
          details: [
            "Morning after breakfast check out from the hotel and go towards Bangkok.",
            "Check in the hotel.and go for the Bangkok city tour and visit",
            "sleeping Buddha and gems gallery",
            "Later go back to the hotel and had your dinner .",
            "Overnight stay at hotel.",
          ],
        },
        {
          day: "Day 04",
          title: "SAFARI WORLD AND MARINE PARK",
          details: [
            "Morning after breakfast go for safari world and marine park.",
            "Safari World and Marine Park in Bangkok is a fun day out for the whole friends.",
            "The variety of things to see and do makes this a fun and enjoyable place for",
            "Go back to the hotel and overnight stay at hotel.",
          ],
        },
        {
          day: "Day 05",
          title: "DEPARTURE BANGKOK",
          details: [
            "After your breakfast checkout from the hotel.",
            "Time for shopping and transfer to airport for board your flight.",
            "Tour Ends",
          ],
        },
      ],
      inclusions: [
        "02 Nights accommodation at Hotel in Pattaya.",
        "02 Nights accommodation at Hotel in Bangkok.",
        "Meal plan on Breakfast and dinner",
        "Coral Island Tour + Lunch",
        "Bangkok City Tour",
        "Safari world",
        "marine park",
        "Tours and Transfers as per the itinerary.",
        "Roundtrip Flight Tickets",
        "Applicable all the Taxes",
      ],
      exclusions: [
        "Personal Expenses",
        "RTPCR TEST",
        "Lunch",
        "Tips",
        "Any other expenses not mentioned in the inclusions",
      ],
    },
    // 4. Thailand Tour 4N/5D (Phuket & Krabi)
    {
      id: 4,
      title: "Thailand Indulgence (Phuket & Krabi)",
      subtitle: "Phuket - Krabi - Phi Phi Island",
      image: phuket1,
      days: 5,
      nights: 4,

      overview: [
        [
          "Thailand’s Phuket, Krabi, and Phi Phi Islands offer a perfect tropical escape with stunning beaches and turquoise waters. Phuket blends vibrant nightlife, luxury resorts, and cultural attractions. Krabi is known for its dramatic limestone cliffs, serene beaches, and emerald lagoons. Phi Phi Islands captivate travelers with crystal-clear seas and scenic island landscapes. Enjoy island hopping, snorkeling, and unforgettable sunset views. This island tour promises relaxation, adventure, and breathtaking natural beauty.🇹🇭",
        ],
      ],
      // duration: "4 Nights / 5 Days",
      itinerary: [
        {
          day: "Day 01",
          title: "PHUKET TO KRABI ENROUTE",
          details: [
            "We’ll meet you at the airport and transfer Krabi and Later drop to the hotel.",
            "Rest of the day at leisure and Overnight in your stay.",
            "(Meals: Breakfast)",
          ],
        },
        {
          day: "Day 02",
          title: "04 ISLANDS TOUR BY SPEED BOAT",
          details: [
            "Breakfast at Hotel",
            "04 Islands tour by Long Tailboat",
            "Snorkeling and swimming at Chicken Island or Koh Kai in Thai because its shape looks like a chicken.",
            "You'll be surprised by the sand banks which separate Chicken Island,Tup and Moore Islands when it is low tide.",
            "Visit Phra Nang Cave at Railay beach",
            "Pick you up fromy our hotel",
            "Get on speed boat to sand banks at Chicken,Tup and Moore Islands.",
            "Snorkeling and swimming at Chicken Island and also have picnic lunch here",
            "Straight to Poda Island for have lunch.",
            "Sun bathing ,swimming and relaxing on the beautiful white sand beach.",
            "Also taking picture with the background of a beautiful standing hill",
            "On the way back we'll pass Phra Nang Cave.",
            "Pray homage to the spirit of Phra Nang.",
            "Back to the pier then transfer you back to your hotel.",
            "Remark:the details of program can be changed depend on the level of the water tide or the condition of the weather.",
            "What to bring:Sunscreen,Sunglasses,Camera,Hat,Towels,Swimmingsuit",
            "Tourincludes:Hotel Transfer,Entrance Fees, Accident Insurance, Mask &Snorkel, Life Jacket ,First-aid Kit, Drinking water, Fruit, Lunch and English-Speaking Guide",
            "Overnight at the Hotel.",
            "(Meals: Breakfast)",
          ],
        },
        {
          day: "Day 03",
          title: "DEPARTURE KRABI TO PHUKET + PHUKET CITY TOUR",
          details: [
            "Breakfast at Hotel and transfer to Phuket hotel.",
            "Later Visit Phuket View Point and Visit century – old Sino-Portuguese building sat Thalang Road and learn more about Phuket’s colorful history.",
            "Overnight in Hotel.",
          ],
        },
        {
          day: "Day 04",
          title: "PHUKET - PHI PHI ISLAND",
          details: [
            "Enjoy cruising by speed boat to Phi Phi Island Group.",
            "Phi Phi Island is one of the best places in the world for its beautiful marine life resources.",
            "Pick you up from your hotel 08.00 - 08.30.",
            "Get on a speed boat for Phi Phi with sightseeing at Viking Cave and Phi Phi lagoon, one of the most beautiful lagoons.",
            "Stop at Loh Sa Ma Bay for swimming, snorkelling.",
            'Heading to Maya Bay,it is very beautiful that is why by the year 2000 it was took the film named "The Beach" there.',
            "After Maya Bay we will go to Monkey Bay.",
            "You will be greeted by many small monkeys.",
            "Have adelicious buffet lunch and relax at the rest aurant on PhiPhi Island.",
            "After lunch more snorkeling at Hin Klang.",
            "It is open sea snorkeling along the colorful coral reef gardens with exotic fish.",
            "By the end we stop and spend the time for swimming, relaxing and sun bathing at Bamboo Island",
            "Back to the pier and transfer you back to your hotel",
            "Remark: the details of program can be changed depending on the tide or the weather conditions.",
            "Tour includes:Hotel Transfer,Entrance,Mask & Snorkel, LifeJacket, First-aid Kit, water/soda, fruit, lunch and English-speaking guide.",
            "Overnight in your stay.",
            "(Meals: Breakfast )",
          ],
        },
        {
          day: "Day 05",
          title: "PHUKET – BANGALORE",
          details: [
            "Ta– Ta!!",
            "After your breakfast at hotel, you have time to freak around the city and shop.",
            "In the morning you depart from Phuket .",
            "Later board your flight for India with the good memories of your trip by M D TOURS AND TRAVELS",
            "(Meals:Breakfast)",
          ],
        },
      ],
      inclusions: [
        "02 nights stay in the Phuket",
        "04Island tour in long tail boat (SIC)",
        "02 nights in Krabi",
        "Krabi to Phuket by Road",
        "Phi Phi Island tour in big boat with (SIC)",
        "Phuket  city tour(PVT)",
        "05 Breakfast at Hotel",
        "Return air port transfers",
        "All sightseeing as mentioned in Itinerary",
        "Airfare & Airport taxes",
        "GST-5.00",
        "Visa Charges of Thailand",
      ],
      exclusions: [
        "Lunch & Dinner",
        "Any other not mentioned in the inclusions.",
        "Personal Expenses",
        "The National Park fees THB400/pax applicable for each Island tours –expense to be paid by client directly.",
        "Early check in and late check out are subject to availability and can not be guaranteed.",
        "Normal check in time is 1400hr sand check out time is1200 hrs.",
      ],
    },
    // 6. Maldives Tour
    {
      id: 6,
      title: "Maldives Serenity",
      subtitle: "Adaaran Club Rannalhi",
      image: maldives1,
      days: 5,
      nights: 6,
      overview:
        " The Maldives is a tropical paradise famous for its turquoise lagoons and pristine white-sand beaches. Stay in luxurious overwater villas offering privacy and breathtaking ocean views. Enjoy snorkeling and diving among vibrant coral reefs and marine life. Relax with world-class spa treatments and serene island surroundings. Experience romantic sunsets, candlelight dinners, and floating breakfasts. A Maldives tour promises ultimate relaxation, luxury, and unforgettable memories. 🇲🇻",
      duration: "5 Days / 6 Nights",
      itinerary: [
        {
          day: "Day 01",
          title: "MALDIVES AIRPORT TO RESORT",
          details: [
            "Upon arrival at the Maldives Airport, you will be met by our local representative for your transfer to the hotel.",
            "After check in at the hotel rest of the day is at leisure.",
            "Overnight at the hotel in Male.",
            "MEALS: DINNER + DRINKS",
          ],
        },
        {
          day: "Day 02",
          title: "MALDIVES",
          details: [
            "Enjoy your day at leisure.",
            "Overnight at the hotel in Male.",
            "MEALS: BREAKFAST + LUNCH + DINNER + DRINKS",
          ],
        },
        {
          day: "Day 03",
          title: "MALDIVES",
          details: [
            "Enjoy your day at leisure.",
            "Overnight at the hotel in Male.",
            "MEALS: BREAKFAST + LUNCH + DINNER + DRINKS",
          ],
        },
        {
          day: "Day 04",
          title: "MALIDIVES",
          details: [
            "Enjoy your day at leisure.",
            "Overnight at the hotel in Male.",
            "MEALS: BREAKFAST + LUNCH + DINNER + DRINKS",
          ],
        },
        {
          day: "Day 05",
          title: "DEPARTURE",
          details: [
            "Check out from the Hotel and Proceed to Male Airport by Speed Boat",
            "End of Service.",
            "MEALS: BREAKFAST + DRINKS",
          ],
        },
      ],
      inclusions: [
        "04 Night Accommodation",
        "Meals All Inclusive Basis (Breakfast + Lunch + Dinner + Drinks)",
        "Return Airport Transfers by Speed Boat",
        "Hotel Taxes",
        "Green Taxes",
        "Honeymoon Benefits (Will advise)",
        "Travel Insurance",
        "Round Flight Fares Inclusive of Taxes",
        "GST and TCS",
      ],
      exclusions: [
        "PCR Test (Pay at property)",
        "Cost of Meals other than those specified in inclusions",
        "Cost of any other services not specifically mentioned in inclusions",
      ],
    },
    // Vietnam 6N/7D
    {
      id: 4,
      title: "Vietnam Essence",
      subtitle:
        "Hanoi - Ninh Binh - Halong Bay - Hanoi - Danang - Coconut Forest - Hoi An ",
      image: vietnam1,
      days: 7,
      nights: 6,
      overview: [
        [
          "Vietnam is a captivating destination known for its rich history, vibrant culture, and breathtaking landscapes. From the bustling streets of Hanoi to the modern energy of Ho Chi Minh City, the country offers diverse experiences. Cruise through the emerald waters of Ha Long Bay and admire its limestone karsts and islands. Explore ancient towns like Hoi An, famous for lantern-lit streets and traditional architecture. Vietnamese cuisine delights travelers with flavorful dishes such as pho, banh mi, and fresh seafood. With warm hospitality and unforgettable scenery, Vietnam offers a perfect blend of culture, nature, and adventure. 🇻🇳",
        ],
      ],

      itinerary: [
        {
          day: "Day 01",
          title: "HANOI ARRIVAL – HALF DAY CITY TOUR",
          details: [
            "Upon arrival in Hanoi, you will be warmly greeted by",
            "Then transfer from the airport to the hotel for check in and rest to regain your energy.",
            "Afternoon, we will visit:",
            "Tran Quoc Pagoda",
            "Hoan Kiem Lake",
            "Train Street: You can visit this special street of Vietnam after dinner, seeing train going through while having a coffee is the best way to enjoy the Vietnamese atmosphere.",
            "Over night Hanoi.",
          ],
        },
        {
          day: "Day 02",
          title: "HANOI – NINH BINH – SIC TOUR",
          details: [
            "Breakfast in the hotel.",
            "7h00 : Our tour guide will pick you up from your hotel. We take you to Ninh Binh province which is far from Hanoi city about 120 km.",
            "9h00 :Have a short break for 20 minutes to relax",
            "10h30: The first destination in this trip is visit Hoa Lu ancient capital.",
            "Come to visit Hoa Lu, you will learn about why the capital was moved to Hanoi nowadays.",
            "You are impressed on an outstanding architecture when entering temples of King Dinh and King Le, the first and second emperors of ancient Vietnam, built in the 17 century.",
            "Try to feel ancient atmospheres in Hoa Lu ancient capital.",
            "12h30: Have buffet local lunch in the restaurant",
            "13h30 – 14h00 : Visit Trang An which was recognized by UNESCO as The world Heritage Site in 2014.",
            "Trang An has the wonderful tunnel cave system so that Kong’s Movie Group chose this place for New Version of Kong in 2016 – “ Skull Island “.",
            "Boat trip to visit Trang An to see the amazing beauty of this landscape with many caves such as : Sang Cave (Light Cave), Toi Cave (Dack cave), Nau Ruou Cave (Cooking Wine), green river and natural view.",
            "16h00 : Get on the bus to return to Hanoi",
            "18h30 – 19h00 : Arrive back to Hanoi and drop off at your hotel or our office in Hanoi.",
            "Overnight in Ha Noi.",
          ],
        },
        {
          day: "Day 03",
          title: "HANOI – HALONG BAY BY BUS – OVERNIGHT ON CRUISE",
          details: [
            "Breakfast in the hotel",
            "07.45 – 08.30: You will be picked up from your hotel in Ha Noi Old Quarter.",
            "Then we will head to Ha Long Bay.",
            "You may enjoy the landscape of the Red River Delta along the way",
            "11.30: Upon arriving in our lobby in Tuan Chau Marina, you may take a short stretch while our staff arranges all registration with the local government.",
            "12.00 – 12.30: The cruise captain and staff will welcome you onboard CRUISE after a short tender transfer.",
            "While enjoying a refreshing welcome drink, a short cruise briefing and safety instructions will be given.",
            "12.30 – 13.00: CRUISE voyages to Ha Long Bay – one of the New Seven Nature Wonders of the World.",
            "Lunch is served on board while the cruise passes via amazing limestone karst formations that rise up out of the sea in an impressive manner.",
            "14.00 – 14.30: You will leave the cruise to explore Sung Sot Cave (also known as Surprise/ Amazing Cave), one of the biggest and most beautiful caves in Ha Long Bay.",
            "15.00: Returning to CRUISE, the trip will continue to Ti Top Island.",
            "Here, you can watch the magnificent view over either the Gulf of Tonkin or swim in the emerald green and cool water.",
            "17.00: After a long day, this is the ideal time to enjoy energizing drinks and snacks by joining ‘Happy Hour’ or Cooking Class on the sundeck",
            "19.30: Sumptuous Dinner is served.",
            "Enjoy delicious local food prepared and served for you by our wonderful onboard catering staff.",
            "20.30: After dinner, various activities including karaoke, and squid fishing are organized.",
            "Overnight on cruise.",
          ],
        },
        {
          day: "Day 04",
          title: "HALONG BAY – HANOI BY BUS – DANANG BY FLIGHT",
          details: [
            "06.15 – 07.00: Breakfast is served.",
            "It can be a great idea to enjoy the meal with the magnificent view of the sunrise in Ha Long Bay.",
            "8.00 -9.30: The cruise gets closer to the center of the Natural Preservation Area.",
            "Join our guide on a short trip to Luon Cave.",
            "You can discover this time masterpiece by kayaking on your own.",
            "9.30: Cruise welcomes you back on board and it is time for checking out.",
            "10.00: Whilst cruising back, delightful lunch will be served.",
            "11.35: We return to the quayside in the south of the bay, where our visitors disembark in Tuan Chau Marina.",
            "15.30 – 16.00: You will get back to your hotel in Ha Noi.",
            "Transfer to Noi Bai airport to take a flight to Danang.",
            "Upon arrival in Danang will take you to your hotel for check in.",
            "Overnight in Danang.",
          ],
        },
        {
          day: "Day 05",
          title: "DANANG – COCONUT FOREST – HOI AN",
          details: [
            "Breakfast at hotel",
            "Depart from the hotel for Coconut Forest",
            "Then drive to visit Bay Mau water coconut forest",
            "Visitors will experience floating down the river by basket boat",
            "Return to Hoian before an afternoon walking tour.",
            "You’ll see the charming, old port of narrow streets and traditional houses.",
            "Then come back to Danang",
            "Overnight in Danang.",
          ],
        },
        {
          day: "Day 06",
          title: "DANANG – BANA HILLS – GOLDEN BRIDGE – SIC",
          details: [
            "Breakfast at the hotel.",
            "07h00 – 08h00: Pick up at HOTEL. Depart to Ba Na Hills.",
            "09h00: Arrive at the cable car station Suoi Mo.",
            "Visit the 150-meter long Golden Bridge supported by the huge hands.",
            "Visit the Le Jardin, Debay Wine Cellar of French.",
            "Visit the Linh Ung pagoda, admire the 27m high Buddha statue.",
            "Continue to Gare Debay use the second cable car route to go to the top of Ba Na.",
            "The tour guide will take guests to visit Fantasy Park.",
            "Freedom to rest. Conquer the Peak of Chua mountain at the height of 1,487m.",
            "Enjoy the panorama view of the Da Nang City and Da Nang Bay.",
            "Then return to cable car station and back to Da Nang.",
            "Overnight in Danang.",
          ],
        },
        {
          day: "Day 07",
          title: "DANANG – DEPARTURE",
          details: [
            "Breakfast in the hotel.",
            "Transfer to Danang airport for departure to next destination.",
            "It’s time to say goodbye, we thank you for traveling with us and warmly welcome you to come again.",
          ],
        },
      ],
      inclusions: [
        "Ground transportation in air-conditioned vehicle",
        "Accommodation at hotel as mentioned or similar ones",
        "Mineral water during excursion 2 bottles/Pax/Day",
        "All services mentioned in the program",
        "Sightseeing tickets",
        "Visa of both countries",
        "Accommodation as indicated above twin including all taxes and breakfast",
      ],
      exclusions: [
        "Surcharge for public holiday or any compulsory dinner on Christmas and New Year",
        "Personal expenses and beverage",
        "Travel insurance",
        "Items of a personal nature",
        "Early check in and late check out surcharge",
        "International and domestic flights including airport tax",
        "Other meals and services not mentioned below",
      ],
    },
    //BALI 5N / 6D
    {
      id: 5,
      title: "Bali Bliss",
      subtitle:
        "Agatti Island - Soutn Beach - Baangaram Thinakara Island - Shallow Lagoon - Sandy Beach",
      image: bali1,
      days: 6,
      nights: 5,
      overview:
        " Bali is a tropical paradise known for its stunning beaches, lush rice terraces, and vibrant culture. The island offers a perfect blend of luxury resorts, spiritual temples, and scenic natural beauty. Visitors can explore iconic spots like Uluwatu Temple, Ubud, and the beautiful Nusa Islands. Bali is also famous for its wellness retreats, traditional Balinese massages, and yoga experiences. Adventure seekers can enjoy water sports, volcano trekking, and jungle activities. With warm hospitality, rich traditions, and breathtaking sunsets, Bali promises an unforgettable holiday experience. 🇮🇩",
      itinerary: [
        {
          day: "01",
          title: "ARRIVAL AGATTI ISLAND",
          details: [
            "On arrival at Agatti airport, our representative will receive and escort you to the Hotel.",
            "After the lunch proceed for Agatti island sightseeing which include – Public Library, anthropological museum, South beach, Eastern jetty (ship embarkation and disembarkation point), NIOT sea water desalination Plant, Lagoon beach a sunset point, relax in the creamy sand for a couple of hours and back to Hotel around 7:00 pm, dinner will be serve at 8:30 pm.",
            "Overnight stay at Agatti.",
          ],
        },
        {
          day: "02",
          title: "AGATTI – SOUTH BEACH FOR WATER SPORTS ACTIVITIES",
          details: [
            "Morning after breakfast proceed to South Beach, nonstop water sports available at the beach, like swimming, snorkeling, kayaking, well equipped SCUBA diving center working at beach which offers Snorkeling, Kayaking, Diving, Glass bottom boat ride on payment.",
            "Guidance of well experienced diving instructor you can enjoy the underwater beauty.",
            "Lunch will be served at the beach on request.",
            "After 4 PM back to Hotel / and relax Hotel/ round, relax in room, dinner will be served at 8:30.",
            "Overnight stay at Agatti.",
          ],
        },
        {
          day: "03",
          title: "AGATTI – BANGARAM  THINAKARA ISLAND DAY TRIP BY PRIVATE BOAT",
          details: [
            "Early morning after breakfast proceeds to Bangaram group of islands beautiful uninhabited island , Bangaram, Tinnakara island , in a single atoll, lying in the northern side of Agatti.",
            "Tour by a private boat from Agatti 45 minutes Journey.",
            "Trip provides beautiful sandy beaches and swimming with turtles, snorkeling in blue shallow water.",
            "After Bangaram sightseeing, boat moves to Thinnakara island , after 5 pm boat moves to Agatti Hotel, relax in room, dinner will be served at 8:30 pm.",
            "Please note movement of the boat to Thinnakara depends on high tide and low tide of sea level",
            "Overnight stay at Agatti.",
          ],
        },
        {
          day: "04",
          title: "ACTIVITIES IN SHALLOW LAGOON",
          details: [
            "After Morning breakfast, enjoy the Glass bottom boating in the lagoon for 1 hour, nonstop water sports available at the beach, like swimming, snorkelling, kayaking up to 12 PM.",
            "Lunch will be served at 1 PM.",
            "After 4:30 pm proceed to Kalpitti island , a small islet in the southern tip of Agatti , which offer swimming and turtle watch, The journey by a small boat in shallow water, sightseeing in the island by walk, after sightseeing Kalpitti island return to Agatti around 6:30 pm.",
            "Overnight stay at Agatti.",
          ],
        },
        {
          day: "05",
          title: "ENJOY THE SANDY BEACH BAREFOOT WALK",
          details: [
            "Enjoy the sandy beach barefoot walk and leisure time at Agatti.",
            "Check out and proceed to Agatti Airport for your return flight.",
            "Tour Ends.",
          ],
        },
      ],
      inclusions: [
        "04 Nights Accommodation",
        "Daily Breakfast",
        "All transfers as per the itinerary",
        "Sightseeing as per the itinerary",
        "Local guide services at Islands",
        "Ferry/Boat transfers as mentioned",
      ],
      exclusions: [
        "Lunch",
        "Personal Expenses",
        "Water Sports charges where applicable",
        "Any other services not mentioned in inclusions",
      ],
    },
    // 1. Switzerland Tour
    {
      id: 9,
      title: "Elite Switzerland",
      subtitle: "Zurich - Lucerne - Interlaken- Jungfraujoch - Rhine Falls",
      image: swiss1,
      days: 5,
      nights: 6,
      // images: [swiss1, swiss2, swiss3, swiss4, swiss5],
      overview:
        "Switzerland is a picture-perfect destination known for its snow-capped Alps, crystal-clear lakes, and charming mountain villages. Enjoy scenic train journeys like the Glacier Express that offer breathtaking panoramic views. Explore iconic cities such as Zurich, Lucerne, and Interlaken blending culture, history, and modern lifestyle. Experience thrilling adventures with cable car rides, mountain excursions, and alpine sports. Indulge in world-famous Swiss chocolates, cheeses, and premium hospitality. A Switzerland tour promises luxury, romance, and unforgettable natural beauty at every turn. 🇨🇭",
      //duration: "5 Days / 6 Nights",
      itinerary: [
        {
          day: "01",
          title: "INDIA - ZURICH STATION – LUCERNE HOTEL",
          details: [
            "Welcome to Lucerne – Switzerland! Later drive to Lucerne City, Upon arrival check In to hotel",
            "Later we visit the Town of Lucerne, to see the Chapel Bridge and the Lion Monument.",
            "Evening, enjoy a Cruise on the beautiful Lake Lucerne.",
            "Overnight stay at Hotel, Lucerne",
          ],
        },
        {
          day: "02",
          title: "MT. TITLIS EXCURSION WITH SWISS PASS",
          details: [
            "A memorable experience awaits you as you depart on an excursion to the glacier paradise of Mount Titlis.",
            "Ascend in the world's first revolving gondola ROTAIR, ride the spectacular ice flyer chairlift and see the ice grotto.",
            "Meal Plan – Breakfast",
          ],
        },
        {
          day: "03",
          title: "LUCERNE – INTERLAKEN",
          details: [
            "Transfer from Lucerne to Interlaken and free day at leisure.",
            "Free day to explore the city on your own with a Swiss pass.",
            "Meal Plan – Breakfast",
          ],
        },
        {
          day: "04",
          title: "INTERLAKEN – JUNGFRAUJOCH",
          details: [
            "Depart on an excursion from Interlaken to Jungfraujoch- Top of Europe.",
            "This memorable train trip from Interlaken Ost takes you via Lauterbrunnen and Wengen to the Kleine Scheidegg, at the foot of the famous Eiger North Wall.",
            "Then ascend by the Jungfrau Railway to the magnificent mountain world of eternal ice and snow, Jungfraujoch-at 3454mts, the highest railway station in Europe.",
            "Visit the Ice Palace and Sphinx Terraces offering breathtaking views of the Aletsch Glacier, the longest glacier in the Alps.",
            "Overnight in Hotel.",
            "Meal Plan – Breakfast",
          ],
        },
        {
          day: "05",
          title: "INTERLAKEN – ZURICH",
          details: [
            "After breakfast, transfer from Interlaken to Zurich.",
            "Visit legendary landmarks like the sophisticated Bahnhofstrasse.",
            "Admire the shimmering surface of Lake Zurich.",
            "Visit the sacred St Peter’s Church and the charming Old Town.",
            "A visit to the Chocolate Lindt Shop!",
            "Meal Plan – Breakfast",
          ],
        },
        {
          day: "06",
          title: "RHINE FALLS FROM ZURICH",
          details: [
            "Breakfast at Hotel",
            "Today, Morning we proceed to Marvel at the Rhine Falls, Europe's biggest waterfall, on this half-day tour from Lucerne.",
            "Travel to Northern Switzerland, a beautiful wine growing region with charming farming villages and scenic landscape near the German border.",
            "Enjoy a full hour to admire and capture photos of the powerful falls, and in summer, take a thrilling boat ride to get a closer look at them.",
            "On arrival in Lucerne, Check in to hotel.",
            "Overnight stay at Hotel, Zurich.",
            "Meal Plan – Breakfast",
          ],
        },
        {
          day: "07",
          title: "DEPARTURE TO INDIA",
          details: [
            "Early Breakfast at Hotel",
            "Check out and proceed to Zurich Airport for your departure flight",
            "Tour Ends",
            "Meal Plan – Breakfast",
          ],
        },
      ],
      inclusions: [
        "02 Night Stay in Zurich",
        "02 Night Stay in Lucerne",
        "02 Night Stay in Interlaken",
        "Meals on Breakfast",
        "All the Tours and Transfers as per the Itinerary",
        "All tips, road tolls, and taxes at the destination included",
        "International Air Tickets",
        "Mount Titlis entry ticket",
        "Jungfraujoch entry ticket",
        "Lindt Chocolate Factory",
        "Rhine Falls day trip from Zurich",
        "One time Visa Charges (Schengen)",
        "Overseas Travel Insurance",
        "Applicable GST",
      ],
      exclusions: [
        "City Tax payable at the time of check-out.",
        "Meals, Tips, Laundry, telephone, optional excursions and other items of a personal nature.",
        "Cost of foreign exchange for personal use.",
        "Any items or services not specified in the itinerary 'PACKAGE INCLUDES' head.",
      ],
    },
  ];

  const domesticPackages = [
    // Kerala 5N/6D Tour
    {
      id: 1,
      title: "Kerala Backwaters",
      subtitle: "Kochi - Munnar - Thekkady - Alleppey - Kollam",
      days: 6,
      nights: 5,
      image: kerala2,
      overview:
        "Kerala tour offers a perfect blend of serene backwaters, lush hill stations, pristine beaches, and rich cultural heritage. Cruise through the famous Alleppey and Kumarakom backwaters on a traditional houseboat. Explore misty hill stations like Munnar, known for tea plantations and breathtaking landscapes. Relax on beautiful beaches such as Kovalam and Varkala along the Arabian Sea. Experience vibrant traditions including Kathakali dance, Ayurveda therapies, and local festivals. Savor authentic Kerala cuisine, featuring fresh seafood, coconut flavors, and aromatic spices.",
      duration: "5 Nights / 6 Days",
      itinerary: [
        {
          day: "Day 01",
          title: "KOCHI AIRPORT TO MUNNAR HOTEL (130KM / 04 HRS)",
          details: [
            "Welcome to God’s Own Country! Following your arrival at the Cochin International Airport, you will be warmly greeted by our tour guides and representatives.",
            "Post this, you will be driven towards Munnar or the ‘Nature Lover’s Paradise’.",
            "Arriving in Munnar, check-in into a hotel or a resort and unwind yourself for a leisure day.",
            "Overnight stay in Munnar",
          ],
        },
        {
          day: "Day 02",
          title: "MUNNAR SIGHTSEEING",
          details: [
            "Brace the playful morning light and wake up to a beautiful morning at the hotel/resort; get freshened up and enjoy a healthy breakfast.",
            "Post this, you will be guided for a full day sightseeing tour - Mattuppetty, Echo Point, Kundala Lake, Photo Point, Elephant Arrival Spot Cinema Shooting, and several other places.",
            "During the day, you will also visit Eravikulam National Park where you can enjoy spotting the exotic Nilgiri Tahr and several other wildlife species.",
            "Post this, a visit to Tata Tea Museum, International Blossom (Hydel) Park, will be visited during the day",
            "Overnight stay in Munnar",
          ],
        },
        {
          day: "Day 03",
          title: "MUNNAR TO THEKKDAY (90KM / 03 HRS)",
          details: [
            "Today morning; following your breakfast at the Munnar hotel/resort, pack your bags and check-out from the hotel/resort.",
            "Hereafter, you will be driven towards the gorgeous Thekkady town.",
            "Following your arrival in the town, settle down in a hotel/resort and relax for a while.",
            "Post this, Embrace the enchanting beauty of God’s Own Country, and take an evening boat ride to national park.",
            "Coming back from the boat ride, you can go for local shopping and enjoy the local flavours of Thekkady",
            "Overnight stay in Thekkady",
          ],
        },
        {
          day: "Day 04",
          title: "THEKKADY TO ALLEPPEY (150 KM / 04 HRS)",
          details: [
            "After breakfast is served at the Thekkady hotel/resort, you will be checked-out and driven towards Alleppey, the ‘Backwater Capital’ of Kerala.",
            "Also known as the ‘Venice of the East’.",
            "Enjoy Alleppey Day House Boat for an hour and in the Evening, Visit Alleppey Beach",
            "Overnight stay in Alleppey",
          ],
        },
        {
          day: "Day 05",
          title: "ALLEPPEY TO KOLLAM",
          details: [
            "After breakfast, check-out from boat house and visit St. Andrew's Basilica, Arthunkal, later proceed to Jatayu Earth Centre.",
            "Morning after breakfast drive to Chadayamangalam to explore the Jatayu earth Centre.",
            "The giant concrete statue of Jatayu is built on a mighty rock named Jatayupara (para means rock in Malayalam).",
            "The colossal statue is 200 feet long, 150 feet wide and 70 feet making is the largest functional bird sculpture in the world with an enter into the Guinness Book of World Records.",
            "The Jatayu Rock Hill that represents the Safety of Women and their Honour",
            "In the evening proceed to Lighthouse and spend some time in the beach.",
            "Later proceed to check-in at hotel and Overnight stay.",
          ],
        },
        {
          day: "Day 06",
          title: "DEPARTURE",
          details: [
            [
              "Today after your breakfast, check-out from your hotel and proceed to Trivendrum Airport, with the sweet memories of your tour with",
              " ",
              <strong> M D TOURS AND TRAVELS.</strong>,
            ],
          ],
        },
      ],
      inclusions: [
        "02 Night Accommodation in Munnar",
        "01 Night Accommodation in Thekkady",
        "01 Night Accommodation in Alleppey – Hotel",
        "01 Night Accommodation in Kollam",
        "Daily Breakfast",
        "Private Vehicle for 06 Days",
        "Return flight fare",
        "Transfers and Sightseeing as per the Itinerary",
        "GST",
      ],
      exclusions: [
        "Lunch & Dinner not included",
        "Entrance Fees for Sightseeing /Activities / Boating",
        "Any expenses not mentioned under the inclusions",
      ],
    },
    // Kashmir 5N/6D Tour
    {
      id: 5,
      title: "Kashmir",
      subtitle: "Srinagar - Gulmarg - Pahalgam - Sonmarg",
      image: kashmir3,
      days: 6,
      nights: 5,
      overview:
        "Kashmir tour offers an enchanting journey through snow-capped mountains, lush valleys, and serene lakes, highlighted by the beauty of Srinagar, Gulmarg, Pahalgam, and Sonmarg; enjoy a shikara ride on Dal Lake, stroll through Mughal gardens, witness breathtaking landscapes and meadows, experience local culture and handicrafts, and savor authentic Kashmiri cuisine, making the trip a perfect blend of nature, tranquility, and unforgettable experiences.",
      itinerary: [
        {
          day: "Day 01",
          title: "ARRIVAL + SHIKARA RIDE",
          details: [
            "Meet our representative at Srinagar airport, transfer to House Boat.",
            "In the evening, Shikara ride in the world famous Dal lake.",
            "Overnight stay at Srinagar.",
            "Meals: Dinner",
          ],
        },
        {
          day: "Day 02",
          title: "SRINAGAR – GULMARG (54 KMS)",
          details: [
            "After breakfast, transfer to Gulmarg via Tangmarg",
            "En-route Apple Orchards, Cherry Orchards (In Summer Time). In Gulmarg visit Khilanmarg",
            'Take a ride in the world\'s highest cable car "Gondola" or enjoy your day by playing golf in the world’s highest golf course.',
            "Overnight stay at Gulmarg.",
            "Meals: Breakfast & Dinner",
          ],
        },
        {
          day: "Day 03",
          title: "GULMARG – PAHALGAM (148 KMS ON WAY)",
          details: [
            "After breakfast, transfer to Pahalgam",
            "Enroute visit Saffron Fields.",
            "In Pahalgam you can visit: - Aru , Betaab valley (at your own cost).",
            "Overnight stay at a hotel in Pahalgam.",
            "Meals: Breakfast & Dinner",
          ],
        },
        {
          day: "Day 04",
          title: "PAHALGAM TO SRINAGAR + SS OF MUGHAL GARDEN (119 KMS ON WAY)",
          details: [
            "After breakfast, transfer to srinagar, check in at the hotel.",
            "Afternoon, leave for local sightseeing of Srinagar City. Visit: - Mughal gardens: - CheshmaShahi (Mughal Spring), Nishat (The Garden of Bliss), Shalimar (The Abode of Love).",
            "Overnight stay at hotel in Srinagar.",
            "Meals: Breakfast & Dinner",
          ],
        },
        {
          day: "Day 05",
          title: "SRINAGAR – SONMARG – SRINAGAR (89 KMS ON WAY)",
          details: [
            "After breakfast, transfer to Sonmarg for a daytrip.",
            "Enroute see Hazratbal Shrine, Gagangir Tourist Village.",
            "The drive from Srinagar to Sonmarg is very beautiful as you will pass through some towns and villages, at many places you can enjoy the view of paddy fields with rivers flowing on one side.",
            "In Sonmarg you can visit Thajwas Glacier which is around 4 Kms from Sonmarg, a local taxi has to be hired for it (at your own cost ).",
            "The name Sonmarg is derived from two Kashmiri words “Son” & “Marg” which mean “Gold” & “Meadow”, when put together it means “Meadow of Gold ''.",
            "Return to Srinagar in the evening after enjoying your day.",
            "Overnight stay at Srinagar.",
            "Meals: Breakfast & Dinner",
          ],
        },
        {
          day: " Day 06",
          title: "DEPARTURE",
          details: [
            "After breakfast, transfer to Srinagar airport, with the memories of your trip organized by RL TOURS & TRAVELS",
          ],
        },
      ],
      inclusions: [
        "01 Night in Houseboat in Dal Lake",
        "01 night in in Pahalgam",
        "01 night in In Gulmarg",
        "02 nights in Srinagar",
        "Meal Plan on (Breakfast + Dinner) basis- Lunch Not Included",
        "All Sightseeing & transfers by NON AC Vehicle",
        "01 hour shikara ride",
        "Return Flight Fares Inclusive of Taxes",
        "Toll, tax, driver allowance for all trips",
        "GST 5%",
      ],
      exclusions: [
        "Lunch",
        "Entrance fees / Tickets to monuments / Park / Cable cars, etc.",
        "Any other expenses not mentioned under the inclusions.",
        "Garden entrance fees and Guide charges, where ever applicable.",
        "Trip to Aru, Chandanwari&Betaab Valley in Pahalgam",
        "Gondola ride in Gulmarg – Have to book online before 10 days minimum.",
        "Thajiwas Glacier & Snow Point in Sonmarg",
        "Snow Jeep from Tangmarg to Gulmarg & back, (Applicable from Nov – February Month)",
        "Item of personal nature viz, tips, laundry, room service, telephone, alcoholic or non-alcoholic beverages, room heaters, boat rides, pony / horse rides, safaris, rafting, skiing, skating, cable car / ropeway rides, helicopter rides, additional sightseeing tours excursions not included in the itinerary, still or video camera fees etc.",
        "Any kind of insurance, Air, Train or Bus fare from / to your originating city of stay, unless specified",
        "Lunch and personal expenses like entry ticket any, telephone laundry, or anything which is not mentioned above.",
        "Any Tax & Government Service tax (5%)",
        "Any Kind of Personal Expenses or Optional Tours / Extra Meals Ordered",
        "Anything not specifically mentioned under the head “Prices included”. The services of vehicle are not included on leisure days & after finishing the sightseeing tour as per the itinerary",
        "Additional costs due to flight cancellation, road blocks etc.",
        "Medical & Travel insurance",
      ],
    },
    //Rajasthan 5N/6D Tour
    {
      id: 2,
      title: "Rajasthan Explorer",
      subtitle: "Jaipur - Jodhpur - Udaipur",
      image: rajasthan1,
      days: 6,
      nights: 5,
      overview:
        "Rajasthan tour covering Jodhpur, Jaipur, and Udaipur offers a rich journey through royal heritage, majestic forts, and grand palaces including Mehrangarh Fort, Amber Fort, and City Palace, while showcasing vibrant bazaars, colorful culture, and traditional Rajasthani lifestyle; the Blue City of Jodhpur reflects timeless history, Jaipur charms with its Pink City architecture and royal legacy, and Udaipur enchants travelers with romantic lakes, serene boat rides, and breathtaking sunset views, all complemented by authentic Rajasthani cuisine and warm royal hospitality.",
      duration: "5 Nights / 6 Days",
      itinerary: [
        {
          day: "Day 01",
          title: "ARRIVAL JAIPUR AND JAIPUR SIGHTSEEING",
          details: [
            "Arrive in Jaipur and proceed to Jaipur Local Sightseeing – Visit Birla Temple, Birla Auditorium and Albert Hall",
            "Lunch at outside restaurant (Own expenses)",
            "Later proceed to Visit Local Market and Nahargarh Fort (sunset view over city)",
            "Return back to hotel and Overnight Stay in Jaipur",
          ],
        },
        {
          day: "Day 02",
          title: "JAIPUR LOCAL SIGHTSEEING",
          details: [
            "Breakfast at Hotel",
            "Proceed to excursion to Amber Fort and enjoy the elephant ride (Direct Pay)- See the largest cannon on wheels in the world, and old cannon foundry at Jaigarh.",
            "Visit to the KanakVrindavan Temple in the valley of flowers.",
            "Drive through the Johari Bazaar or the old jeweler's market to HawaMahal (Palace of Winds).",
            "Visit the various museums inside the City Palace and the ancient observatory and JantarMantar.",
            "Evening free for your independent activities and Return back to hotel and Overnight in Jaipur",
            "Meals – Breakfast and Dinner",
          ],
        },
        {
          day: "Day 03",
          title: "JAIPUR TO JODHPUR VIA AJMER AND PUSHKER (09 HRS / 400 KMS)",
          details: [
            "After breakfast, check out of the hotel and proceed to Udaipur via Ajmer and Pushker",
            "Driver will take you to Visit the Dargah Sharif - a pilgrimage Centre for the shrine of the Sufi Saint KhwajaMoinuddinChishti , here are thousands of pilgrims come every day and made more famous by the movies and the Bollywood celebrities this place is worth a visit.",
            "After that you will drive for Holy City of PushkarUpon arrival to Pushkar - we will Firstly take you to visit the Brahma Temple the one and only temple in the world dedicated to Brahma, the creator of the world in Hindu mythology. Legend has it that his wife placed a curse on him that restricts his worship to this one city.",
            "After that driver will take you to the Pushkar Lake which is surrounded by 52 bathing ghats (a series of steps leading to the lake), where pilgrims throng in large numbers to take a sacred bath, A dip in the sacred lake is believed to cleanse sins and cure skin diseases.",
            "After Seeing the Beauty of Pushkar City, proceed to Jodhpur",
            "Upon arrival Jodhpur, check in to hotel and overnight stay in Jodhpur",
            "Meals – Breakfast & Dinner",
          ],
        },
        {
          day: "Day 04",
          title: "JODHPUR TO UDAIPUR (250 KMS)",
          details: [
            "Breakfast from Hotel. Later checkout and proceed to Udaipur.",
            "Arrival at Udaipur, proceed to the hotel.",
            "Check in to the Hotel",
            "Dinner and Overnight stay at Hotel in Udaipur",
            "Meals – Breakfast and Dinner",
          ],
        },
        {
          day: "Day 05",
          title: "UDAIPUR SIGHTSEEING",
          details: [
            "Breakfast from Hotel",
            "Proceed to Udaipur Sightseeing tour – Visit Museum of Folk Art, which has a rich collection of folk dresses, puppets, dolls, masks, ornaments, folk musical instruments and paintings on display.",
            "Afterwards, visit the City Palace, the biggest palace complex in India, where four generations of Maharajas added mansions and palaces. You must also visit the museum of the palace which includes the beautiful peacock mosaic and miniature wall paintings of Indian mythology.",
            "The visit Durbar Hall, Crystal Art Gallery, Jagdish Temple, MaharanaPratap Memorial and drive past the FatehSagar Lake",
            "Return back to hotel and overnight stay",
            "Meals – Breakfast and Dinner",
          ],
        },
        {
          day: " Day 06",
          title: "UDAIPUR SHOPPING AND DROP TO UDAIPUR AIRPORT",
          details: [
            "After your breakfast check-out from Hotel and het dropped to Airport.",
            [
              "Drop off Jaipur Airport with the great memories of your tour organized by RL TOURS AND TRAVELS",

              " ",
              <strong> M D TOURS AND TRAVELS.</strong>,
            ],
            "Meals – Breakfast",
          ],
        },
      ],
      inclusions: [
        "02 Nights’ Accommodation in Jaipur",
        "01 Night Accommodation in Jodhpur",
        "02 Night Accommodation in Udaipur",
        "Meal Plan on Breakfast & Dinner Basis",
        "Sedan Card for 06 Days",
        "Tours and Transfers as per the Itinerary",
        "01 Ltr Water bottle Per Person Per Day",
        "Round Flight Fares Inclusive of Taxes",
        "Applicable all the taxes",
      ],
      exclusions: [
        "Lunch",
        "Personal expenses",
        "Entrance Tickets & Ticket for other activities",
        "Any other expense not mentioned in the inclusions",
      ],
    },
    // Goa
    {
      id: 5,
      title: "Goa",
      subtitle:
        "North Goa - Coco Beach - Calangute Beach - Baga Beach - Anjuna Beach",
      image: goa1,
      days: 3,
      nghts: 2,
      overview:
        "Goa tour offers a vibrant coastal experience with pristine beaches, historic architecture, and lively nightlife; the journey includes visits to iconic locations like Panaji, Calangute Beach, and Baga Beach, along with cultural attractions such as the Shri Shantadurga Temple and Old Goa Churches; perfect for beach lovers, couples, and those seeking a blend of relaxation and adventure.",
      duration: "2 Nights / 3 Days",
      itinerary: [
        {
          day: "DAY 01",
          title: "BANGALORE TO GOA",
          details: [
            "As you arrive at the Goa airport/railway station, an agent’s representative will receive you and escort you to the hotel. Complete-check-in formalities and relax for some time.",
            "Spend the entire first day of your Goa trip leisurely. Explore the sun-kissed beaches of Goa or try some amazing Goa delicacies like Goa fish curry.",
            "As you bid goodbye today one of your Goa holiday, come back to the hotel and have a goodnight’s sleep.",
            "Overnight stay at Hotel",
          ],
        },
        {
          day: "DAY 02",
          title: "EXPLORING THE BEACHES OF NORTH GOA CITY TOUR",
          details: [
            "Have breakfast and get ready to embark on a full-day North Goa sightseeing tour.",
            "The first attraction that you will visit on your North Goa tour is the ancient Fort Aguada.",
            "Later, explore Coco Beach, Calangute Annexe, Calangute Beach, Baga Beach and Anjuna Beach.",
            "As the second day of your Goa tour itinerary comes to an end, come back to the hotel and sleep off the night.",
            "Overnight stay at Hotel",
            "Meals: Breakfast",
          ],
        },
        {
          day: "DAY 03",
          title: "DEPARTURE",
          details: [
            "After Breakfast check out",
            "You depart with the memories of your tour arranged by M D TOURS AND TRAVELS",
          ],
        },
      ],
      inclusions: [
        "02 Night Accommodation at Goa with Breakfast",
        "All Tours and Transfers as per the Itinerary.",
        "All transfers using sedan vehicle",
        "Flight tickets one way",
      ],
      exclusions: [
        "Any expenses other than mentioned in the Inclusions",
        "Lunch & Dinner",
        "Entrance Fees not included",
      ],
    },
    // Shimla Manali 6N/7D Tour
    {
      id: 5,
      title: "Shimla & Manali",
      subtitle: "Chandigarh - Shimla - Manali",
      image: shimla2,
      days: 7,
      nights: 6,
      overview:
        "Shimla and Manali tour offers a refreshing Himalayan escape with colonial charm and scenic mountain beauty, featuring the pleasant hill town of Shimla with its heritage architecture, Mall Road, and panoramic views, along with Manali’s snow-capped peaks, lush valleys, Solang Valley adventures, and serene riverside landscapes; the journey is ideal for nature lovers, honeymooners, and adventure seekers, blending relaxation, sightseeing, and unforgettable mountain experiences.",
      duration: "6 Nights / 7 Days",
      itinerary: [
        {
          day: "Day 01",
          title: "CHANDIGARH TO SHIMLA (130 KMS / 04 HRS)",
          details: [
            "On arrival at Chandigarh Airport and Meet Our Representative Then drive to Shimla",
            "On arrival Check in Shimla Hotel.",
            "Overnight Stay at Hotel.",
            "Meals – Dinner",
          ],
        },
        {
          day: "Day 02",
          title: "SHIMLA (FULL DAY TRIP TO KUFRI & LOCAL)",
          details: [
            "After Breakfast Excursion to Kufri. Kufri is famous for its Himalayan National Park, Pony and Yak Ride and one can see the endless Himalayan Panorama from Kufri, after lunch sightseeing of various places in and around.",
            "Shimla mosques built in (1830). Vice regal Lodge built in (1885), Christ Church built in (1844)",
            "The Gaiety Theatre- the first beauty contest of world was supposed to start (1887), The Grind lays Bank (1912)- the world wide bank started. by Robert Melville Grind lay",
            "The Scandal Point and the famous Shopping Plaza of the North the Mall.",
            "stay & Dinner at Hotel.",
            "Meals – Breakfast & Dinner",
          ],
        },
        {
          day: "Day 03",
          title: "SHIMLA – MANALI (270 KMS / 08 HRS)",
          details: [
            "After Breakfast, Proceed to Manali via Pandoh Dam approx., Hanogi Mata Temple.",
            "Evening Check in hotel.",
            "Dinner & Overnight stay at hotel",
            "Meals – Breakfast & Dinner",
          ],
        },
        {
          day: "Day 04",
          title:
            "SOLANG VALLEY (ROHTANG PASS ON DIRECT PAYMENT BASSIC SUBJECT TO PERMIT (20 K.M ROUND TOUR)",
          details: [
            "Rohtang Pass. Situated at an altitude of 3979 mtrs above sea level and 51 kms outside Manali is the mighty Rohtang Pass – the gateway to Lahaul-Spiti valley.",
            "It affords a wide panoramic view of the mountains. Here one sees the majesty of the mountains at its height and splendor.",
            "At the top of the pass the air seems to glitter against the snow as you look down over herringboned ridges into the Lahaul valley",
            "Overnight stay at hotel.",
            "Meals – Breakfast & Dinner",
          ],
        },
        {
          day: "Day 05",
          title: "MANALI LOCAL SIGHTSEEING",
          details: [
            "After breakfast proceed to Manali Local sightseeing – Visit - Hidimba Temple, club house, Vashisht hot spring, Tibetan Monastery, Van vihar, Mall road by walk.",
            "Overnight stay at hotel.",
            "Meals – Breakfast & Dinner",
          ],
        },
        {
          day: "Day 06",
          title: "MANALI – KULLU – CHANDIGARH (320 KMS / 10 HRS)",
          details: [
            "After Breakfast check out hotel. Depart for Chandigarh.",
            "On the way visit Kullu Vaishno Devi Temple, Kullu shawl weaving In.",
            "Chandigarh is the1st planned modern city of India designed by the French architect Le Corbusier.",
            "The city was named after the mother goddess of power, Chandi, whose temple Chandimandu is a feature of the new city",
            "On arrival check in hotel and Overnight stay at hotel",
            "Meals – Breakfast & Dinner",
          ],
        },
        {
          day: "Day 07",
          title: "DEPARTURE",
          details: [
            "After Breakfast check out hotel. Visit Rose Garden, Rock Garden, Lake.",
            "Drop off Airport",
            "Tour Ends.",
            "You depart from Chandigarh with the enthralling memories of your trip with M D TOURS AND TRAVELS.",
            "Meals – Breakfast",
          ],
        },
      ],
      inclusions: [
        "02 Night Accommodation in Shimla",
        "03 Night Accommodation in Manali",
        "01 Night Accommodation in Chandigarh",
        "Daily Breakfast & Dinner in all the places",
        "Vehicle for 07 Days",
        "Entry tickets for sightseeing",
        "AC Not applicable in Hilly areas",
        "All sightseeing covered as per the itinerary.",
        "Round Trip Flight Fares inclusive of Taxes",
      ],
      exclusions: [
        "Lunch not included",
        "All optional items",
        "Expenses of personal nature like drinks, personal insurance, tips and telephone calls.",
        "Any additional expenses due to unforeseen problems like natural disaster, war or strikes, cancellation or misconnection of flight or last minute change of timings etc.",
        'Any other service, which has not been specified as "included".',
      ],
    },
    //Mussoorie
    {
      id: 10,
      title: "Mussoorie & Rishikesh Retreat",
      subtitle: "Dehradun – Mussoorie – Rishikesh",
      image: mussoorie1,
      days: 4,
      Nights: 3,
      overview: [
        [
          "Mussoorie and Rishikesh together offer a perfect blend of serene hill-station charm and spiritual rejuvenation. Mussoorie, the ‘Queen of Hills’, is known for its pleasant climate, scenic viewpoints, waterfalls, and colonial-era charm. Rishikesh, nestled along the sacred River Ganga, is a global hub for yoga, meditation, and adventure activities. This journey combines nature, relaxation, spirituality, and light adventure, making it ideal for families, couples, and seekers of peace.🏔️🕉️",
        ],
      ],
      duration: "3 Nights / 4 Days",
      itinerary: [
        {
          day: "01",
          title: "ARRIVAL IN DEHRADUN – TRANSFER TO MUSSOORIE",
          details: [
            "Arrived at Dehradun Airport / Railway Station",
            " Meet and Greet on arrival",
            " Drive to Mussoorie",
            "*Approx 1.5-2 hours drive*",
            " Check in Hotel",
            " Evening visit to Mall Road",
            " Overnight stay in Mussoorie",
          ],
        },
        {
          day: "02",
          title: "MUSSOORIE SIGHTSEEING",
          details: [
            " Breakfast at the Hotel",
            " Visit Kempty Falls",
            " Visit Gun Hill Point (by ropeway)",
            " Visit Camel’s Back Road",
            " Visit Lal Tibba",
            " Evening free for leisure",
            " Overnight stay in Mussoorie",
          ],
        },
        {
          day: "03",
          title: "MUSSOORIE – RISHIKESH",
          details: [
            " Breakfast at the Hotel",
            " Check out from Hotel",
            " Drive to Rishikesh",
            "*Approx 2.5-3 hours drive*",
            " Check in Hotel",
            " Visit Laxman Jhula & Ram Jhula",
            " Visit Parmarth Niketan Ashram",
            " Evening Ganga Aarti at Triveni Ghat / Parmarth Niketan",
            " Overnight stay in Rishikesh",
          ],
        },
        {
          day: "04",
          title: "DEPART RISHIKESH",
          details: [
            " Early morning Yoga / Meditation (optional)",
            " Breakfast at the Hotel",
            " Check out from Hotel",
            " Transfer to Dehradun Airport / Railway Station",
            " Departure with Refreshing Memories",
          ],
        },
      ],
      inclusions: [
        "Hotel Accommodation",
        "Daily Hotel Breakfast",
        "All transfers and sightseeing as per itinerary",
        "Driver allowance, tolls and parking",
      ],
      exclusions: [
        "Airfare / Train fare",
        "Adventure activities (rafting, bungee, etc.)",
        "All personal expenses",
        "Meals not mentioned in the itinerary",
        "Travel Insurance",
        "5% GST and bank transfer charges",
      ],
    },
  ];

  const travelerGalleryImages = [
    { id: 101, src: image1, alt: "School Trip" },
    { id: 102, src: image2, alt: "Vietnam Trip" },
    { id: 104, src: image3, alt: "Vietnam Trip" },
    { id: 106, src: image5, alt: "❤️❤️❤️❤️" },
    { id: 105, src: image4, alt: "💐💐💐💐" },
    { id: 107, src: image6, alt: "❤️❤️❤️❤️" },
  ];

  // Function to open the Gallery Modal (kept)
  const openGalleryModal = (image) => {
    setSelectedGalleryImage(image);
    setShowGalleryModal(true);
  };

  // --- Carousel Scroll Logic (unchanged) ---
  const handleScroll = (ref, setActiveIndex, isGallery = false) => {
    if (ref.current) {
      const cardWidth = isGallery
        ? ref.current.firstChild.offsetWidth + 15
        : ref.current.firstChild.offsetWidth + 30;
      const scrollLeft = ref.current.scrollLeft;
      const index = Math.round(scrollLeft / cardWidth);
      setActiveIndex(index);
    }
  };

  const scrollTo = (ref, index, isGallery = false) => {
    if (ref.current && ref.current.firstChild) {
      const cardWidth = isGallery
        ? ref.current.firstChild.offsetWidth + 15
        : ref.current.firstChild.offsetWidth + 30;
      ref.current.scrollTo({
        left: cardWidth * index,
        behavior: "smooth",
      });
    }
  };

  const handleGalleryScroll = () =>
    handleScroll(galleryCarouselRef, setActiveGalleryIndex, true);
  const scrollToGalleryIndex = (index) =>
    scrollTo(galleryCarouselRef, index, true);
  const handleIntScroll = () =>
    handleScroll(internationalCarouselRef, setActiveIntIndex);
  const scrollToIntIndex = (index) => scrollTo(internationalCarouselRef, index);
  const handleDomScroll = () =>
    handleScroll(domesticCarouselRef, setActiveDomIndex);
  const scrollToDomIndex = (index) => scrollTo(domesticCarouselRef, index);

  useEffect(() => {
    const intCarousel = internationalCarouselRef.current;
    if (intCarousel) intCarousel.addEventListener("scroll", handleIntScroll);
    const domCarousel = domesticCarouselRef.current;
    if (domCarousel) domCarousel.addEventListener("scroll", handleDomScroll);
    const galleryCarousel = galleryCarouselRef.current;
    if (galleryCarousel)
      galleryCarousel.addEventListener("scroll", handleGalleryScroll);

    return () => {
      if (intCarousel)
        intCarousel.removeEventListener("scroll", handleIntScroll);
      if (domCarousel)
        domCarousel.removeEventListener("scroll", handleDomScroll);
      if (galleryCarousel)
        galleryCarousel.removeEventListener("scroll", handleGalleryScroll);
    };
  }, [travelerGalleryImages.length]);

  const handleVideoEnd = () => {
    setCurrentVideo((prev) => (prev + 1) % videos.length);
  };

  const whatsappNumber = "917337864840";

  // --- CONDITIONAL RENDERING ---
  if (selectedPackage) {
    return (
      <PackageDetailView
        pkg={selectedPackage}
        setExpandedPackage={setSelectedPackage}
        whatsappNumber={whatsappNumber}
      />
    );
  }
  // --- END CONDITIONAL RENDERING ---

  return (
    <div className="home-container">
      {/* HERO VIDEO CAROUSEL */}
      <div className="hero-banner">
        <video
          className="hero-video"
          src={videos[currentVideo]}
          autoPlay
          loop={false}
          muted
          playsInline
          onEnded={handleVideoEnd}
        />
        <div className="hero-text">
          <h1>Discover Your Next Adventure</h1>
          <p>
            Explore the best destinations with our exclusive travel packages
          </p>
        </div>
      </div>

      {/* INTERNATIONAL PACKAGE CAROUSEL */}
      <h2 className="section-title">
        ✈️ Top Selling International Destinations
      </h2>
      <div className="carousel-wrapper">
        <div className="package-carousel" ref={internationalCarouselRef}>
          {internationalPackages.map((pkg) => (
            <div key={pkg.id} className="package-card-wrapper">
              <div
                className="package-card"
                onClick={() => setSelectedPackage(pkg)} // OPENS FULL PAGE
              >
                <div className="package-img-container">
                  <img
                    src={pkg.image}
                    className="package-img"
                    alt={pkg.title}
                  />
                </div>

                <CardContent className="card-info-content">
                  <Typography variant="h6">{pkg.title}</Typography>
                  <div className="card-icon">
                    <CalendarMonthIcon className="duration-icon-list" />
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      className="duration"
                    >
                      {pkg.days} Days / {pkg.nights} Nights
                    </Typography>
                  </div>
                </CardContent>
              </div>
            </div>
          ))}
        </div>
        <div className="carousel-dots">
          {internationalPackages.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === activeIntIndex ? "active" : ""}`}
              onClick={() => scrollToIntIndex(index)}
            ></span>
          ))}
        </div>
      </div>

      {/* DOMESTIC PACKAGE CAROUSEL */}
      <h2 className="section-title">🇮🇳 Top Selling Domestic Destinations</h2>
      <div className="carousel-wrapper">
        <div className="package-carousel" ref={domesticCarouselRef}>
          {domesticPackages.map((pkg) => (
            <div key={pkg.id} className="package-card-wrapper">
              <div
                className="package-card"
                onClick={() => setSelectedPackage(pkg)} // OPENS FULL PAGE
              >
                <div className="package-img-container">
                  <img
                    src={pkg.image}
                    className="package-img"
                    alt={pkg.title}
                  />
                </div>
                {/* <h3>{pkg.title}</h3>
                <p>
                  {pkg.days} Days / {pkg.nights} Nights
                </p> */}
                <CardContent className="card-info-content">
                  <Typography variant="h6">{pkg.title}</Typography>
                  <div className="card-icon">
                    <CalendarMonthIcon className="duration-icon-list" />
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      className="duration"
                    >
                      {pkg.days} Days / {pkg.nights} Nights
                    </Typography>
                  </div>
                </CardContent>
              </div>
            </div>
          ))}
        </div>
        <div className="carousel-dots">
          {domesticPackages.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === activeDomIndex ? "active" : ""}`}
              onClick={() => scrollToDomIndex(index)}
            ></span>
          ))}
        </div>
      </div>

      {/* TRAVELER PHOTO GALLERY CAROUSEL */}
      <div className="gallery-section-container">
        <h2 className="section-title">Captured Moments</h2>
        <h4 className="section-subtitle">Because Every Picture Has a Story</h4>
        <div className="carousel-wrapper gallery-wrapper">
          <div className="gallery-carousel-track" ref={galleryCarouselRef}>
            {travelerGalleryImages.map((image) => (
              <div
                key={image.id}
                className="gallery-image-item"
                onClick={() => openGalleryModal(image)}
              >
                <img
                  src={image.src}
                  className="gallery-image"
                  alt={image.alt}
                />
                <p className="image-caption">{image.alt}</p>
              </div>
            ))}
          </div>
          <div className="carousel-dots gallery-dots">
            {travelerGalleryImages.map((_, index) => (
              <span
                key={index}
                className={`dot ${
                  index === activeGalleryIndex ? "active" : ""
                }`}
                onClick={() => scrollToGalleryIndex(index)}
              ></span>
            ))}
          </div>
        </div>
      </div>
      {/* --- END HOME SCREEN STRUCTURE --- */}

      {/* GALLERY IMAGE MODAL (Lightbox - IMPLEMENTED HERE) */}
      {showGalleryModal && selectedGalleryImage && (
        <div
          className="modal-overlay gallery-modal-overlay"
          onClick={() => setShowGalleryModal(false)}
        >
          <div
            className="gallery-modal-box"
            onClick={(e) => e.stopPropagation()}
          >
            <span
              className="modal-close-x"
              onClick={() => setShowGalleryModal(false)}
            >
              &times;
            </span>
            <img
              src={selectedGalleryImage.src}
              alt={selectedGalleryImage.alt}
              className="gallery-modal-image"
            />
            <p className="gallery-modal-caption">{selectedGalleryImage.alt}</p>
          </div>
        </div>
      )}

      {/* WHATSAPP BUTTON (Fixed on screen - unchanged) */}
      <a
        href={`https://wa.me/${whatsappNumber}`}
        target="_blank"
        rel="noreferrer"
        className="whatsapp-btn"
      >
        <img
          src={whatsapp}
          alt="WhatsApp"
          style={{ width: "32px", height: "32px" }}
        />
      </a>
    </div>
  );
}
